import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const IMAGE_CDN = process.env.REACT_APP_PUBLIC_IMAGE_BASE_URL || '';
const VIDEO_CDN = process.env.REACT_APP_PUBLIC_VIDEO_BASE_URL || '';

const resolveMediaUrl = (url?: string) => {
  if (!url) return '';

  // already absolute
  if (/^https?:\/\//i.test(url)) return url;

  const clean = url.replace(/^\//, '');
  const isVideo = /\.(mp4|webm|mov|m4v)$/i.test(clean);

  const base = isVideo ? VIDEO_CDN : IMAGE_CDN;
  return `${base.replace(/\/$/, '')}/${clean}`;
};


const EditMedia = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();


  const { mediaItem } = location.state || {};

  if (!mediaItem) {
    return <div>{t('editMedia.noItem')}</div>;
  }
    
  const handleSave = () => {
    console.log("Save changes for:", mediaItem);
    navigate(-1); // Go back to the previous page
  };

  return (
    <div style={editContainerStyle}>
      <h2>{t('editMedia.title')}</h2>
      <div style={editImageContainerStyle}>
 <img
  src={
    mediaItem.url
      ? resolveMediaUrl(mediaItem.url)
      : mediaItem.file
      ? URL.createObjectURL(mediaItem.file)
      : ''
  }
  alt={t('editMedia.alt')}
  style={editImageStyle}
/>


      </div>
      <button style={editButtonStyle} onClick={handleSave}>
        {t('editMedia.save')}
      </button>
    </div>
  );
};


const editContainerStyle: React.CSSProperties = {
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const editImageContainerStyle: React.CSSProperties = {
  marginBottom: '20px',
};

const editImageStyle: React.CSSProperties = {
  maxWidth: '70%',
  maxHeight: '70%',
  objectFit: 'cover',
};

const editButtonStyle: React.CSSProperties = {
  padding: '10px 20px',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
};

export default EditMedia;
